module.exports = new __parcel__URL__("skeptical_cat.fb018691.webp").toString();